import React, { useEffect, useState,useMemo } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { useDispatch,useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import ComponentCard from '../../../../components/ComponentCard';
import CustomButton from '../../../Common/CustomButton';
import plus from '../../../../assets/images/project-img/plusIcon.png';
import ReusableDataTable from '../../../Common/ReusableDataTable';
import AddLuggageRack from './AddLuggageRack';
//import ViewLuggageRack from './ViewLuggageRack';
import LuggageRackFlowHistoryModal from '../LuggageRackFlowHistoryModal';
import ViewLuggageRackModal from '../ViewLuggageRackModal';
// import { hasPermission } from '../../../../utils/permissionUtils';
import {
  fetchLuggageRacklist,
  deleteLuggageRack,
} from '../../../../store/page/furnishing/furnishingThunk';
import FurnishingFilter from '../../../Common/FurnishingFilter';
import { fetchAllUnderFrameType } from '../../../../store/page/frametype/frametypeThunk';

const LuggageRackList = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [editData, setEditData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [handelAddnewForm, setHandelAddnewForm] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedStageId, setSelectedStageId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [listingData, setlistingData] = useState([]);
  const [selectedShellNo, setSelectedShellNo] = useState(''); 

  const user = JSON.parse(localStorage.getItem('user')) || {};
const userRole = user.role;
const userId = user.id;

  const [confirmFilter, setConfirmFilter] = useState('all');
  const [flowStatusFilter, setFlowStatusFilter] = useState('all');
  const [shellTypeFilter, setShellTypeFilter] = useState('all');
  const shellTypes = useSelector((state) => state?.frametypesReducer?.all_uf_types || []);

  useEffect(() => {
    dispatch(fetchAllUnderFrameType());
  }, [dispatch]);

  // Filter only Vande Bharat (vende-bharat) coach types
  const vandeBharatCoachTypes = useMemo(() => {
    if (!shellTypes || !Array.isArray(shellTypes) || shellTypes.length === 0) {
      console.log('No underframe data available');
      return [];
    }

    const filtered = shellTypes.filter((coach) => {
      const trainType = coach.train_type || '';
      return trainType === 'vende-bharat';
    });

    return filtered;
  }, [shellTypes]);

  console.log(70, vandeBharatCoachTypes);

  const flowStatusOptions = [
    { value: 'all', label: 'All' },
    { value: '0', label: 'Reinspection' },
    { value: '1', label: 'Forwarded' },
    { value: '2', label: 'Freeze' },
  ];

  // Using the specialized FurnishingFilter
  const handleFilterChange = (filterKey, value) => {
    switch (filterKey) {
      case 'confirming':
        setConfirmFilter(value);
        break;
      case 'flow_status':
        setFlowStatusFilter(value);
        break;
      case 'shell_type':
        setShellTypeFilter(value);
        break;
      default:
        break;
    }
    setCurrentPage(1);
  };

  const handleReset = () => {
    setConfirmFilter('all');
    setFlowStatusFilter('all');
    setShellTypeFilter('all');
    setCurrentPage(1);
  };

  // const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
  // const user = JSON.parse(localStorage.getItem('user')) || {};
  // const userRole = user.role;
  // const userId = user.id;

  // Empty fetch data function
  const fetchData = () => {
    setLoading(true);
    dispatch(
      fetchLuggageRacklist({
        page: currentPage,
        perPage,
        search: searchText,
        confirming: confirmFilter !== 'all' ? confirmFilter : '',
        flow_status: flowStatusFilter !== 'all' ? flowStatusFilter : '',
        shell_type: shellTypeFilter !== 'all' ? shellTypeFilter : '',
      }),
    )
      .unwrap()
      .then((response) => {
        console.log('api response:', response?.data);
        if (response?.status === true) {
          setlistingData(response?.data || []);
        } else {
          setlistingData([]);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, perPage, searchText, confirmFilter, flowStatusFilter, shellTypeFilter]);

  const handleAddForm = () => {
    setHandelAddnewForm(!handelAddnewForm);
    if (handelAddnewForm) {
      setEditData(null);
      setViewData(null);
    }
  };

  const handleView = (rowData) => {
    setViewData(rowData.originalData);
    setEditData(null);
    setHandelAddnewForm(true);
  };

  // const handleEdit = (rowData) => {
  //   setEditData(rowData.originalData);
  //   setViewData(null);
  //   setHandelAddnewForm(true);
  // };
//  const handleEdit = (rowData) => {
//   const { originalData } = rowData;
//   const { shell_type: shellType } = originalData;
  
//   const shellTypeId = shellType?.id || shellType?._id || shellType || '';
  
//   setEditData({
//     ...originalData,
//     shell_type: shellTypeId,
//   });
//   setViewData(null);
//   setHandelAddnewForm(true);
// };
  const handleEdit = (rowData) => {
    const { originalData } = rowData;
    const { shell_type: shellType } = originalData;

    const id = rowData.id || rowData.originalData?.id || rowData.originalData?._id || rowData._id;

    const shellTypeId = shellType?.id || shellType?._id || shellType || '';
    setEditData({
      ...originalData,
      id,
      shell_type: shellTypeId,
      confirming: originalData.confirming !== undefined && originalData.confirming !== null
        ? String(originalData.confirming)
        : '',
    });
    setViewData(null);
    setHandelAddnewForm(true);
  };
  const handleDelete = async (id) => {
    console.log('Delete ID:', id);
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: 'This record will be deleted permanently.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Delete',
    });

    if (!confirm.isConfirmed) return;

    try {
      const response = await dispatch(deleteLuggageRack(id)).unwrap();
      if (response?.status !== true) {
        throw new Error(response?.message || 'Delete Failed');
      } else {
        toast.success('Deleted Successfully');
        fetchData();
      }
    } catch (error) {
      toast.error(error?.message || error || 'Delete Failed');
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (sizePerPage) => {
    setPerPage(sizePerPage);
    setCurrentPage(1);
  };

  const handleSearchChange = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handleViewHistory = (rowData) => {
    setSelectedStageId(rowData.originalData.id);
     setSelectedShellNo(rowData.originalData.shell_no || '');
    setShowHistory(true);
  };

  const handleSuccess = () => {
    fetchData();
    setHandelAddnewForm(false);
    setEditData(null);
    setViewData(null);
  };

  // const canEdit = (rowData) => {
  //   const flowStatus = rowData?.originalData?.status;
  //   const submittedBy = rowData?.originalData?.inspect_by_id;

  //   if ((flowStatus === 2 || flowStatus === 3) && userRole === 'admin') {
  //     return true;
  //   }

  //   if (
  //     (flowStatus === 2 || flowStatus === 3) &&
  //     submittedBy &&
  //     String(submittedBy) === String(userId)
  //   ) {
  //     return true;
  //   }

  //   return false;
  // };

    const canEdit = (rowData) => {
    // const flowStatus = rowData?.originalData?.flow_status;
    const submittedBy = rowData?.originalData?.inspect_by;

    if (userRole === 'admin') return true;

    if (submittedBy && String(submittedBy) === String(userId)) return true;

    return false;
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const columns = [
    {
      dataField: 'serial_no',
      text: 'Sl No.',
      isKey: true,
      width: '80',
    },
    {
      dataField: 'shift',
      text: 'Shift',
      width: '80',
    },
    {
      dataField: 'shell_type_name',
      text: 'Shell Type',
      width: '120',
    },
    {
      dataField: 'shell_no',
      text: 'Shell No',
      width: '100',
    },
    {
      dataField: 'inspect_by',
      text: 'Inspect By',
      width: '100',
    },
    {
      dataField: 'insp_format_date',
      text: 'Inspection Date',
      width: '140',
    },
    {
      dataField: 'created_at',
      text: 'Submitted Date',
      width: '140',
    },
    {
      dataField: 'confirming',
      text: 'Status',
      width: '150',
      formatter: (cell) => {
        if (cell === null || cell === undefined || cell === '') {
          return <span className="badge bg-dark">NA</span>;
        }

        const isConfirming = String(cell) === '1';

        return (
          <span className={`badge ${isConfirming ? 'bg-success' : 'bg-danger'}`}>
            {isConfirming ? 'Conforming' : 'Non Conforming'}
          </span>
        );
      },
    },
    {
      dataField: 'flow_status',
      text: 'Flow Status',
      width: '180',
      formatter: (cell,rowData) => {
        const statusMap = {
          0: {
            label: 'Reinspection',
            className: 'bg-warning text-dark',
          },
          1: {
            label: 'Forwarded',
            className: 'bg-primary',
          },
          2: {
            label: 'Freeze',
            className: 'bg-success',
          },
        };

        const status = statusMap[cell] || {
          label: 'Unknown',
          className: 'bg-secondary',
        };

          let formattedFreezeDate = '';
        if (cell === 2 && rowData.freeze_date) {
          const d = new Date(rowData.freeze_date);
            if (!Number.isNaN(d.getTime())) {
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            formattedFreezeDate = `${dd}-${mm}-${yyyy}`;
          } else {
            formattedFreezeDate = `${rowData.freeze_date}`;
          }
        }

        return <span className={`badge ${status.className}`}>{status.label} {cell === 2 && formattedFreezeDate ? ` / ${formattedFreezeDate}` : ''}</span>;
      },
    },
    {
      dataField: 'action',
      text: 'Action',
      width: '260',
      formatter: (cell, rowData) => {
        // const isEditAllowed = canEdit(rowData);
        return (
          <div className="d-flex align-items-center gap-2">
            {/* {hasPermission(permissions, 'inspection_view') && ( */}
            <>
              <button
                type="button"
                id={`view-${rowData.id}`}
                onClick={() => handleView(rowData)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px',
                }}
              >
                <i className="bi bi-eye text-info" style={{ fontSize: '18px' }} />
              </button>

              <UncontrolledTooltip target={`view-${rowData.id}`} placement="bottom">
                View
              </UncontrolledTooltip>
            </>
            {/* )} */}

            {/* {hasPermission(permissions, 'inspection_edit') && isEditAllowed && ( */}
             {rowData?.flow_status === 0 && canEdit(rowData) ? (
              <>
                <button
                  type="button"
                  id={`edit-${rowData.id}`}
                  onClick={() => handleEdit(rowData)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                  }}
                >
                  
                  <i className="bi bi-pencil-square text-primary" style={{ fontSize: '18px' }} />
                </button>

                <UncontrolledTooltip target={`edit-${rowData.id}`} placement="bottom">
                  Edit
                </UncontrolledTooltip>
              </>
            ) : (
              ''
            )}
            {/* <>
                <button
                  type="button"
                  id={`edit-${rowData.id}`}
                  onClick={() => handleEdit(rowData)}
                  style={{
                    background: 'none',
                    border: '1px solid #0d6efd',
                    cursor: 'pointer',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    color: '#0d6efd',
                  }}
                >
                  Reinspection
                </button>

                <UncontrolledTooltip target={`edit-${rowData.id}`} placement="bottom">
                  Reinspection
                </UncontrolledTooltip>
              </> */}
            {/* )} */}

            <button
              type="button"
              id={`history-${rowData.id}`}
              onClick={() => handleViewHistory(rowData)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
              }}
            >
              <i className="bi bi-clock-history text-success" style={{ fontSize: '18px' }} />
            </button>

            <UncontrolledTooltip target={`history-${rowData.id}`} placement="bottom">
              View History
            </UncontrolledTooltip>

            {/* {hasPermission(permissions, 'inspection_delete') && ( */}
            <div>
              <button
                type="button"
                id={`delete-${rowData.id}`}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px',
                }}
                onClick={() => handleDelete(rowData.id)}
              >
                <i className="bi bi-trash text-danger" style={{ fontSize: '16px' }} />
              </button>

              <UncontrolledTooltip target={`delete-${rowData.id}`} placement="bottom">
                Delete
              </UncontrolledTooltip>
            </div>
            {/* )} */}
          </div>
        );
      },
    },
  ];

  const tableData =
    listingData?.map((item, index) => ({
      id: item.id,
      originalData: item,
      serial_no: index + 1 + (currentPage - 1) * perPage,
      shift: item.shift_type?.name || '-',
      shell_type_name: item.shell_type?.title || '-',
      shell_no: item?.shell_dtls?.form_no,
      furnishing_no: item.furnishing_no,
      inspect_by: item.inspect_user.name,
      // insp_format_date: item.date,
      insp_format_date: item.date ? formatDate(item.date) : 'N/A',
      created_at: item.created_at ? formatDate(item.created_at) : 'N/A',
      status: item.status,
      confirming: item.confirming,
      flow_status: item.flow_status,
      freeze_date: item.freeze_date || null
    })) || [];

  const totalRecords = tableData?.length || 0;

  return (
    <>
      <ComponentCard
        title={`Luggage Rack (Total: ${totalRecords})`}
        action={
          <div className="d-flex gap-2 align-items-center">
            <CustomButton
              image={plus}
              label="Add New"
              color="transparent"
              onClick={handleAddForm}
              className="addBTnStyle"
            />
          </div>
        }
      >
        {/* Filters */}
        <FurnishingFilter
          onFilterChange={handleFilterChange}
          onReset={handleReset}
          conformingValue={confirmFilter}
          flowStatusValue={flowStatusFilter}
          shellTypeValue={shellTypeFilter}
          shellTypeOptions={vandeBharatCoachTypes}
          flowStatusOptions={flowStatusOptions}
          className="mb-3"
        />
        <ReusableDataTable
          data={tableData}
          columns={columns}
          search
          pagination
          loading={loading}
          remote
          totalSize={totalRecords}
          currentPage={currentPage}
          perPage={perPage}
          onPageChange={handlePageChange}
          onSizePerPageChange={handlePerPageChange}
          onSearchChange={handleSearchChange}
          noDataMessage="No records found"
        />
      </ComponentCard>

      {/* Add/Edit Modal */}
      {handelAddnewForm && !viewData && (
        <AddLuggageRack
          toggle={handleAddForm}
          isOpen={handelAddnewForm}
          editData={editData}
          onSuccess={handleSuccess}
        />
      )}

      {/* View Modal */}
      {viewData && (
        <ViewLuggageRackModal
          toggle={handleAddForm}
          isOpen={!!viewData}
          viewData={viewData}
          onSuccess={handleSuccess}
        />
      )}

      {/* History Modal */}
      <LuggageRackFlowHistoryModal
        isOpen={showHistory}
        toggle={() => {
          setShowHistory(false);
          setSelectedShellNo('');
        }}
        stageId={selectedStageId}
        shellNo={selectedShellNo}
        moduleType="luggage_rack_inspection"
      />
    </>
  );
};

export default LuggageRackList;
